import BaseErrorOverlay from './BaseErrorOverlay';
import { Paper } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    errorWrapper: {
        display: 'grid',
        padding: theme.spacing(3),
        position: 'relative',
        minHeight: '300px',
        zIndex: 1,
        fontSize: 21,
        '& .MuiSvgIcon-root': {
            fontSize: 36,
            color: theme.palette.error.main,
        },
    },
}));

const ErrorOverlay = props => {
    const { classes } = useStyles(undefined, {
        props,
    });

    return (
        <Paper className={classes.errorWrapper}>
            <BaseErrorOverlay {...props} />
        </Paper>
    );
};

ErrorOverlay.propTypes = {
    error: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.string,
    ]),
    defaultLabel: PropTypes.string,
};

export default ErrorOverlay;
